import React from 'react'
import styled from '../../theme'
import { useTranslation } from 'react-i18next'
import Badge from './Badge'
import { useSelector } from 'react-redux'
import {
  getAirbnbListings,
  getAirbnbStatus,
  getAirbnbSync,
} from '../../reducers/airbnb/selectors'
import { IntegrationStatus, IntegrationSync } from '../../reducers/airbnb'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`

const Title = styled.div`
  font-size: 15px;
  color: #121212;
  font-family: Montserrat, sans-serif;
  font-weight: bold;
`

function AirbnbHeader() {
  const { t } = useTranslation()

  const listings = useSelector(getAirbnbListings)
  const sync = useSelector(getAirbnbSync)
  const licenseValid = useSelector(isLicenseValid)
  const status = useSelector(getAirbnbStatus)

  const syncing =
    sync === IntegrationSync.Syncing &&
    listings.some(l => l.bedbooking_id_room) &&
    licenseValid

  const everyConnected = listings.every(l => !!l.bedbooking_id_room)
  const connected = listings.filter(l => !!l.bedbooking_id_room).length

  return (
    <Wrapper>
      <Title
        style={{
          marginRight: '20px',
          marginBottom: '5px',
        }}
      >
        {t('OUT_4829_airbnb_title_window_title')}
      </Title>
      <Badge
        status={syncing ? 1 : 0}
        text={
          syncing
            ? t('OUT_4829_airbnb_title_on')
            : t('OUT_4829_airbnb_title_off')
        }
      />
      {status === IntegrationStatus.Integrated && (
        <Badge
          status={syncing && everyConnected ? 1 : 0}
          text={`${connected}/${listings.length} ${t(
            'OUT_4829_airbnb_title_room_connected',
          )}`}
        />
      )}
      {!licenseValid && (
        <Badge status={2} text={t('OUT_4829_airbnb_title_no_premium')} />
      )}
    </Wrapper>
  )
}

export default AirbnbHeader
